import styled, { css, keyframes } from 'styled-components'
import { customTheme } from '../../styles/theme'

interface ICardProps {
  type: 'done-group' | 'done' | 'current' | 'blocked';
  borderColor?: string;
}
interface IMobileProps {
  $isMobile: boolean;
  $heightLimited?: boolean;
  $paddingEdit?: boolean;
}

interface ButtonProps {
  stat: 'done-group' | 'done' | 'current' | 'blocked'
}
interface StatProps {
  parent: boolean,
  type: 'done-group' | 'done' | 'current' | 'blocked' | any
}

const background = keyframes`
 from {
    background: linear-gradient(90deg, ${customTheme.colors.green} 57.91%, rgba(50, 205, 50, 0) 100%);
    background-position: 120% 100%;
  }
 to {
    background: linear-gradient(90deg, rgba(50, 205, 50, 0) 0%, ${customTheme.colors.green} 54.85%);
    background-position: 100% 100%;
  }
`

const floating = keyframes`
  0% {
    transform: translatey(0px);
  }

  50% {
    transform: translatey(2px);
  }

  100% {
    transform: translatey(0px);
  }
`

export const Wrapper = styled.div`
  position: relative;
  /* margin-bottom: 10px; */
`

export const HandleOpenButton = styled.button<ButtonProps>`
  position: absolute;
  right: -50px;
  font-size: 30px;
  height: 40px;
  width: 40px;
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  color: #FFA1AD;
  top:  ${({ stat }) => stat === 'current' ? '17px' : '8px'};
  display: none;
`

export const Container = styled.div<ICardProps>`
  width: 100%;
  height: 9vh;
  padding: 24px;
  margin: 0 auto 10px;

  & + & {
    margin-top: 16px;
  }

  border-radius: 92.2669px;

  display: flex;
  align-items: center;
  justify-content: space-between;

  ${({ type, borderColor }) => {
    if (type === 'done') {
      return css`
        background: rgba(255, 255, 255, 0.2);
        border: 1.84534px solid ${borderColor};
        box-shadow: 0px 7.23636px 35.2773px rgba(0, 0, 0, 0.18);
        backdrop-filter: blur(54.4375px);
      `
    } else if (type === 'current') {
      return css`
        height: 11vh;
        background: linear-gradient(90deg, ${customTheme.colors.green} 57.91%, rgba(50, 205, 50, 0) 100%);
        border: 3px solid ${customTheme.colors.green};
        filter: drop-shadow(0px 7.23636px 35.2773px rgba(0, 0, 0, 0.5));
        backdrop-filter: blur(54.4375px);
        margin-top: -6px;
        cursor: pointer;
      
        animation: ${background}  10s infinite;
        -webkit-animation: ${background}  10s infinite;
        -moz-animation: ${background}  10s infinite;
        animation: ${floating}  1s ease-in-out infinite;
        -webkit-animation: ${floating}  1s ease-in-out infinite;
        -moz-animation: ${floating}  1s ease-in-out infinite;
      `
    } else {
      return css`
        background: rgba(255, 255, 255, 0.2);
        border: 1.84534px solid rgba(188, 188, 188, 0.74);
        box-shadow: 0px 7.23636px 35.2773px rgba(0, 0, 0, 0.18);
        backdrop-filter: blur(54.4375px);
      `
    }
  }}

  @media (max-width: ${customTheme.breakpoints[1]}) {
    width: 95%;
    padding: 10px!important;
    height: 60px;
  }
`

export const CardTitle = styled.h2<ICardProps>`
  display: flex;
  align-items: center;

  ${({ type }) => {
    if (type === 'current') {
      return css`
        font-weight: bold;
        font-size: 24px;
        line-height: 36px;
        color: ${customTheme.colors.white};

        @media (max-width: ${customTheme.breakpoints[1]}) {
          font-size: 14px;
          line-height: 1;
        }
      `
    } else {
      return css`
        font-weight: bold;
        font-size: 16px;
        line-height: 24px;
        color: ${customTheme.colors.white};

        @media (max-width: ${customTheme.breakpoints[1]}) {
          line-height: 1;
          font-size: 14px;
        }
      `
    }
  }}
`

export const DoneText = styled.span`
  display: flex;
  align-items: center;
  
  margin-left: 10px;

  font-weight: 500;
  font-size: 15.97px;
  line-height: 24px;
  letter-spacing: 0.01em;
  color: ${customTheme.colors.green};

  @media (max-width: ${customTheme.breakpoints[1]}) {
    font-size: 12px;
  }
`

export const BlockedText = styled.span`
  display: flex;
  align-items: center;
  
  margin-left: 15px;

  font-weight: 500;
  font-size: 15.97px;
  line-height: 24px;
  letter-spacing: 0.01em;
  color: #E1E1E1;

  & > svg {
    margin-top: -6px;
    margin-left: 6px;
  }

  @media (max-width: ${customTheme.breakpoints[1]}) {
    font-size: 12px;
  }
`

export const CardExtra = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (max-width: ${customTheme.breakpoints[1]}) {
    img {
      display: none;
    }
  }
`

export const CardPoints = styled.div`
  margin-right: 10px;

  display: flex;
  align-items: center;
`

export const CardPointValue = styled.span`
  font-weight: bold;
  font-size: 24px;
  line-height: 36px;
  color: #FFFFFF;

  @media (max-width: ${customTheme.breakpoints[1]}) {
    font-size: 16px;
  }
`

export const CardPointImage = styled.img`
  margin-left: 10px;
  max-width: 50px;
  max-height: 50px;
  object-fit: contain;

  @media (max-width: ${customTheme.breakpoints[1]}) {
    display: none;
  }
`

export const ChildrenList = styled.div`
  overflow: hidden;
  transition: ease all 500ms;
  display: none;
`

export const MissionStatWrapper = styled.div`
  position: absolute;
  left: -70px;
  top: 50%;
  transform: translateY(-50%);
  /* height: 100%;
  display: flex;
  align-items: center;
  overflow: hidden; */

  @media (max-width: ${customTheme.breakpoints[1]}) {
    left: -45px;
  }
`

export const MissionStat = styled.div<StatProps>`
  width: ${({ parent }) => parent ? '37px' : '30px'};
  height: ${({ parent }) => parent ? '37px' : '30px'};
  background: ${customTheme.colors.white};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9;
  box-shadow: 1px 1px 1px 1px #d8d8d8;

  & > svg path {
    fill: ${({ type }) => type === 'blocked' ? '#A6B4C6' : customTheme.colors.green};
  }
`

export const MissionStatBar = styled.div<any>`
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  width: 4px;
  height: 9vh;
  /* background: ${({ type }) => type === 'blocked' || type === 'current' ? '#A6B4C6' : customTheme.colors.green}; */
  background: #A6B4C6;
  z-index: 2;

  @media (max-width: ${customTheme.breakpoints[1]}) {
    height: 50px;
  }
`

// ------------ MOBILE-----------//

export const ExternContainerMobile = styled.div<IMobileProps>`
  display: flex;
  flex-direction: 'row';
  align-items: center;
  justify-content: ${({ $isMobile }) => $isMobile ? 'flex-start' : 'space-evenly'};
  
  background-color: #f8f6f7;
  padding: 0.5em;
  border-radius: 0.5em;

  position: relative;

   ${({ $isMobile, $paddingEdit }) => $isMobile && (
    `
      max-height: 45%;
      margin: 0 0.8em 0.8em 0.8em;
      margin-top: 3%;
      ${$paddingEdit && ('padding-top: 15px;')}

    `
  )}
   ${({ $isMobile, $heightLimited }) => !$isMobile && (
    `
      cursor: pointer;
      gap: 10px;
      box-shadow: 0px 7.23636px 35.2773px rgba(0, 0, 0, 0.08);
      border: 1px solid #e4e4e4;
      ${$heightLimited ? 'max-height: 200px;' : 'min-height: 200px;'}
    `
  )}

  @media (max-width: ${customTheme.breakpoints[1]}) {
    min-width: 32%;
  }
  &:hover {
    background-color: #f3f3f3;
  }

`

export const ExternContainerMobileFinished = styled.div<IMobileProps>`
  margin-top: 3%;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  max-height: 45%;
  opacity: 0.5;
  min-width: 23%;
  ${({ $isMobile }) => $isMobile && ('max-width: 23%;')};
  
  height: 100%;
  min-height: 100%;
`

export const WrapperMobile = styled.div<IMobileProps>`
  position: relative;
  padding: ${({ $isMobile }) => $isMobile ? '1.2vw' : ''};
  display: flex;
   ${({ $isMobile }) => $isMobile && ('flex-grow: 1;')}
  height: ${({ $isMobile }) => $isMobile ? 'calc(16vw)' : ''};
  aspect-ratio: 1/1;
  margin: 0 2% 0 0;
  justify-content: center;
  align-items: center;
  min-width: 20%;
  max-width: 20%;
`

export const WrapperMobileFinished = styled.div<IMobileProps>`
  position: relative;
  padding: ${({ $isMobile }) => $isMobile ? '2px' : '2px'};
  background: rgb(90,255,90);
  display: flex;
  flex-grow: 1;
  min-height: ${({ $isMobile }) => $isMobile ? '6.5vh' : '5.5vh'};
  min-width: ${({ $isMobile }) => $isMobile ? '6.5vh' : '5.5vh'};
  max-height: ${({ $isMobile }) => $isMobile ? '6.5vh' : '5.5vh'};
  max-width: ${({ $isMobile }) => $isMobile ? '6.5vh' : '5.5vh'};
  margin: 0 5%;
  border-radius: 50%;
  justify-content: center;
`

export const ContainerMobile = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background: rgb(92,159,109);
  background: linear-gradient(15deg, rgba(92,159,109,1) 0%, rgba(78,109,107,1) 95%);
  padding: 0.7vw;
`
export const ContainerMobileFinished = styled.div`
  width: 100%;
  min-width: 100%;
  max-width: 100%;
  height: 100%;
  min-height: 100%;
  max-height: 100%;
  border-radius: 50%;
  background-color: #000;
  padding: 2px;
  aspect-ratio: 1/1;
`

export const Content = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background-color: #FFF;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const Points = styled.div`
  position: absolute;
  bottom: -13px;
  display: flex;
  align-self: center;
  background-color: #F4F4F4;
  padding: 2px 5px;
  border-radius: 12px;

  h5 {
    font-weight: 400;
    font-size: ${customTheme.fontSizes.xs};
    text-align: center;
    white-space: nowrap;
    color: ${customTheme.colors.black};
  }
`
export const PointsFinished = styled.div`
  display: flex;
  align-self: center;
  background-color: #FFF;
  padding: 2px 5px;
  border-radius: 12px;
  margin-top: 5px;
  margin-bottom: 3px;

  h5 {
    font-weight: 400;
    font-size: ${customTheme.fontSizes.xs};
    text-align: center;
    white-space: nowrap;    
    color: ${customTheme.colors.black};
  }
`

export const IconFinished = styled.div<IMobileProps>`
  position: absolute;
  top: -2px;
  right: -4px;
  height: ${({ $isMobile }) => $isMobile ? '2.5vh' : '2vh'};
  width: ${({ $isMobile }) => $isMobile ? '2.5vh' : '2vh'};
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(90deg, rgba(90,255,90,1) 18%, rgba(112,238,112,1) 70%, rgba(82,200,82,1) 100%);
  border-radius: 50%;
  border: 1.5px solid #000;
`

export const MissionName = styled.div<IMobileProps>`
  ${({ $isMobile }) => !$isMobile && (`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  `)}
  
  h4 {
    font-weight: 600;
    font-size:  ${({ $isMobile }) => $isMobile ? customTheme.fontSizes.xs : '1.3rem'};
    white-space: normal;
    overflow: hidden;
    text-overflow: ellipsis;
    line-clamp: 2;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    display: -webkit-box;
    
    color: ${({ color }) => color || customTheme.colors.black};
    ${({ $isMobile }) => !$isMobile && ('text-align: center;')}
  }

  h5 {
    margin-top: 0.4em;
    font-weight: 400;
    ${({ $isMobile }) => !$isMobile && ('font-size: 1rem;')}
    ${({ $isMobile }) => !$isMobile && ('text-align: center;')}
  }
`
export const InstructionStart = styled.div<any>`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  text-align: center;

  svg {
    width: 30px;

    @media (max-width: ${customTheme.breakpoints[1]}) {
      width: 15px;

    }
  }

  h4 {
    font-weight: 600;
    font-size: ${customTheme.fontSizes.xs};
    white-space: normal;
    overflow: hidden;
    text-overflow: ellipsis;
    line-clamp: 2;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    display: -webkit-box;
    font-size: 25px;
    
    color: #000;

    @media (max-width: ${customTheme.breakpoints[1]}) {
      font-size: 14px;
      line-height: 1;
    }
  }
`
export const InstructionStartAsync = styled.div<IMobileProps>`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  text-align: center;

  ${({ $isMobile }) => !$isMobile && (
    `position: absolute;
    top: 5px;`
  )}

  ${({ $isMobile }) => $isMobile && (
    `position: absolute;
    top: 5px;
    right: 10px;`
  )}
  
  svg {
    width: 30px;

    @media (max-width: ${customTheme.breakpoints[1]}) {
      width: 15px;

    }
  }

  h4 {
    font-weight: 600;
    font-size: ${customTheme.fontSizes.xs};
    white-space: normal;
    overflow: hidden;
    text-overflow: ellipsis;
    line-clamp: 2;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    display: -webkit-box;
    font-size: 25px;
    
    color: #000;

    @media (max-width: ${customTheme.breakpoints[1]}) {
      font-size: 14px;
      line-height: 1;
    }
  }
`
export const Separator = styled.span<IMobileProps>`
    background: #d7d7d7;
    width: 1px;
    height: 50%;
    ${({ $isMobile }) => $isMobile && ('display: none')};
`
